module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    attrs: {
      "id": "main-header"
    }
  }, [_c('div', {
    staticClass: "cc-inside"
  }, [_c('div', {
    staticClass: "columns cc-align-center"
  }, [_c('div', [_c('router-link', {
    staticClass: "logo cc-primary",
    attrs: {
      "to": {
        name: 'home'
      },
      "exact": ""
    }
  }, [_vm._v("\n                        ChuckCSS & VueJS Admin\n                    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "cc-w-auto cc-right"
  }, [_c('notifications', {
    attrs: {
      "loggedUser": _vm.loggedUser
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "cc-w-auto"
  }, [_c('router-link', {
    staticClass: "user-box",
    attrs: {
      "to": {
        name: 'user-profile',
        params: {
          id: _vm.loggedUser.id
        }
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.loggedUser.picture,
      "alt": _vm.loggedUser.name
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("capitalize")(_vm.loggedUser.name)))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "cc-w-auto"
  }, [_c('div', {
    staticClass: "header-icon"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openSettingsPanel($event)
      },
      "mouseenter": function($event) {
        _vm.isHoverSettings = true
      },
      "mouseleave": _vm.delayClosePanel
    }
  }, [_c('i', {
    staticClass: "ion-ios-gear-outline"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown",
    class: {
      shown: _vm.showSettings
    },
    on: {
      "mouseenter": function($event) {
        _vm.isHoverSettings = true
      },
      "mouseleave": _vm.delayClosePanel
    }
  }, [_c('li', {
    staticClass: "cc-clearfix"
  }, [_c('a', {
    staticClass: "cc-red",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeSettingsPanel($event)
      }
    }
  }, [_c('i', {
    staticClass: "ion-close-round"
  })]), _vm._v(" "), _c('p', [_vm._v("\n                                    Settings\n                                ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$store.dispatch('switchTooltips'), _vm.closeSettingsPanel()
      }
    }
  }, [_c('i', {
    staticClass: "ion-ios-help-outline"
  }), _vm._v(" " + _vm._s(_vm.getTooltipMsg) + "\n                                ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout($event)
      }
    }
  }, [_c('i', {
    staticClass: "ion-ios-unlocked-outline"
  }), _vm._v(" Logout\n                                ")])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4ad83231!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/header.vue
// module id = 222
// module chunks = 0